import { render, staticRenderFns } from "./dg-pasw-intensity.vue?vue&type=template&id=586f4094&scoped=true"
import script from "./dg-pasw-intensity.vue?vue&type=script&lang=js"
export * from "./dg-pasw-intensity.vue?vue&type=script&lang=js"
import style0 from "./dg-pasw-intensity.vue?vue&type=style&index=0&id=586f4094&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586f4094",
  null
  
)

export default component.exports